export enum MetadataKey {
  // Common
  FEEDBACK_GIVEN = 'feedbackGiven',
  FLOWS = 'flows',

  // B2B
  HIDE_DMS_INFO_MODAL_HOME = 'hideDmsInfoModalHome',
  HIDE_DMS_INFO_MODAL_JOB_OPENINGS = 'hideDmsInfoModalJobOpenings',
  HIDE_PAYMENT_DETAILS_WARNING = 'hidePaymentDetailsWarning',
  HIDE_SUPPORT_TICKET_NOTICE = 'hideSupportTicketNotice',
  HIDE_COURSE_OF_STUDY_INFO = 'hideCourseOfStudyInfo',

  // B2C
  ONBOARDING_DONE = 'onboardingDone',
  INTERACTED_WITH_MOTIVATION_STEP = 'interactedWithMotivationStep',
  VISITED_STUDY_ADVICE_VIEW = 'visitedStudyAdviceView',
  HIDE_B2C_STUDY_MATCH_INTEREST_MODAL = 'hideB2cStudyMatchInterestModal',
  UNLOCKED_STEP2_ALREADY = 'unlockedStep2already',
  UNREAD_JOB_OPENINGS = 'unreadJobOpenings',
  VISITED_SELFMATCHING_VIEW = 'visitedSelfMatchingView',
  MATCHING_QUIZ_DONE = 'matchingQuizDone',
  READY_TO_MOVE = 'readyToMove',
}
